import { Dialog, Rating } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const getDragDropStyle = (isDragging, isOver, canDrop) => (theme) => ({
  opacity: isDragging ? 0.5 : 1,
  backgroundColor: isOver && canDrop ? alpha(theme.palette.primary.main, 0.1) : "transparent",
  borderTop: isOver && canDrop ? `2px dashed ${theme.palette.primary.main}` : "none",
  borderBottom: isOver && canDrop ? `2px dashed ${theme.palette.primary.main}` : "none",
  cursor: "move",
  transition: "all 0.2s ease",
});

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    minWidth: 400,
    padding: theme.spacing(2),
  },
}));